import { render } from "./ReportsDialog.vue?vue&type=template&id=2ddb74fd"
import script from "./ReportsDialog.vue?vue&type=script&lang=js"
export * from "./ReportsDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__